// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: '/login',
  merchant: '/merchant',
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  //root: ROOTS_DASHBOARD, //prepro收起
  root: path(ROOTS_DASHBOARD, '/ecommerce'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'), //prepro收起
    home: path(ROOTS_DASHBOARD, '/home'),
    SchoolCourse: path(ROOTS_DASHBOARD, '/SchoolCourse'),
    SmallActivity: path(ROOTS_DASHBOARD, '/SmallActivity'),
    Exhibition: {
      list: path(ROOTS_DASHBOARD, '/Exhibition'),
      detail: path(ROOTS_DASHBOARD, '/Exhibition/detail')
    },
    schoolBased: path(ROOTS_DASHBOARD, '/school-based'),
    schoolBasedAdd: path(ROOTS_DASHBOARD, '/school-based/add'),
    schoolBasedEdit: path(ROOTS_DASHBOARD, '/school-based/edit/:activity_id'),
    schoolBasedEditStudentReport: path(
      ROOTS_DASHBOARD,
      '/school-based/edit/:activity_id/view-report'
    ),
    schoolBasedEditStudentReportDetail: path(
      ROOTS_DASHBOARD,
      '/school-based/edit/:activity_id/view-report/:student_id'
    ),
    curriculumActivities: path(ROOTS_DASHBOARD, '/curriculum-activities'),
    curriculumActivitiesList: path(ROOTS_DASHBOARD, '/curriculum-activities'),
    curriculumActivitiesNew: path(ROOTS_DASHBOARD, '/curriculum-activities/new'),
    curriculumActivitiesEdit: path(ROOTS_DASHBOARD, '/curriculum-activities/edit/:activity_id'),
    curriculumActivitiesViewState: path(
      ROOTS_DASHBOARD,
      '/curriculum-activities/view-state/:activity_id'
    ),
    curriculumActivitiesViewStateStudent: path(
      ROOTS_DASHBOARD,
      '/curriculum-activities/view-state/:activity_id/class/:class_id'
    ),
    curriculumActivitiesViewStateStudentDetail: path(
      ROOTS_DASHBOARD,
      '/curriculum-activities/view-state/:activity_id/class/:class_id/student/:student_id'
    ),
    schoolBasedViewState: path(ROOTS_DASHBOARD, '/school-based/view-state/:activity_id'),
    schoolBasedViewStateStudent: path(
      ROOTS_DASHBOARD,
      '/school-based/view-state/:activity_id/class/:class_id'
    ),
    schoolBasedViewStateStudentDetail: path(
      ROOTS_DASHBOARD,
      '/school-based/view-state/:activity_id/class/:class_id/student/:student_idd'
    ),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    customList: path(ROOTS_DASHBOARD, '/customList'),
    schoolResource: path(ROOTS_DASHBOARD, '/schoolResource'),
    additionResource: path(ROOTS_DASHBOARD, '/extra-resource'),
    aplusQuestionBank: {
      root: path(ROOTS_DASHBOARD, '/aplus-question-bank'),
      questions: path(ROOTS_DASHBOARD, '/aplus-question-bank/questions'),
      newQuestion: path(ROOTS_DASHBOARD, '/aplus-question-bank/questions/new'),
      bulkImport: path(ROOTS_DASHBOARD, '/aplus-question-bank/bulk-import')
    },
    aplusCampaign: {
      root: path(ROOTS_DASHBOARD, '/aplus-campaign'),
      newCampaign: path(ROOTS_DASHBOARD, '/aplus-campaign/new')
    },
    internalQuestionBank: {
      dashboard: path(ROOTS_DASHBOARD, '/internal-question-bank'),
      questions: path(ROOTS_DASHBOARD, '/internal-question-bank/questions'),
      newQuestion: path(ROOTS_DASHBOARD, '/internal-question-bank/questions/new'),
      chineseWordBank: path(ROOTS_DASHBOARD, '/internal-question-bank/chinese-word-bank'),
      taxonomy: path(ROOTS_DASHBOARD, '/internal-question-bank/taxonomy')
    },
    SchoolResourceList: path(ROOTS_DASHBOARD, '/shool-resource-new'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
    TrashCanList: path(ROOTS_DASHBOARD, '/schoolResource/trashCan'),
    lessonPlanTools: path(ROOTS_DASHBOARD, '/lessonPlanTools'),
    platformResourceLibrary: path(ROOTS_DASHBOARD, '/platform-resource-library')
  },
  parentChildTask: {
    list: path(ROOTS_DASHBOARD, '/parentChildTask/list'),
    add: path(ROOTS_DASHBOARD, '/parentChildTask/add'),
    edit: path(ROOTS_DASHBOARD, '/parentChildTask/edit'),
    view: path(ROOTS_DASHBOARD, '/parentChildTask/view')
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  setting: path(ROOTS_DASHBOARD, '/setting'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  },
  // 帳戶管理
  account: {
    root: path(ROOTS_DASHBOARD, '/account/staff/list'),
    authority: path(ROOTS_DASHBOARD, '/account/authority/list'),
    AddAuthority: path(ROOTS_DASHBOARD, '/account/authority/add'),
    EditAuthority: path(ROOTS_DASHBOARD, '/account/authority/edit')
  }
};

export const PATH_DOCS = 'https://www.evigarten.com';
